import { render, staticRenderFns } from "./BodyForm.vue?vue&type=template&id=38b39444&scoped=true&"
import script from "./BodyForm.vue?vue&type=script&lang=js&"
export * from "./BodyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b39444",
  null
  
)

export default component.exports